<template>
  <div
    class="structure df both-side"
    v-for="item in props.structureData"
    :key="item.id"
    @click="handleUpdateStructure(item)"
  >
    <div class="df vertical">
      <div class="icon df vertical df-center">
        <ClusterOutlined />
      </div>
      {{ item.structureName }}
    </div>
  </div>
</template>

<script>
import { defineComponent, watch } from "vue";
import { ClusterOutlined, EditOutlined } from "@ant-design/icons-vue";

export default defineComponent({
  name: "StructureNode",
  components: { ClusterOutlined, EditOutlined },
  props: {
    structureData: Array,
  },
  setup(props, context) {
    const handleUpdateStructure = (record) => {
      context.emit("handleUpdateStructure", record);
    };
    return {
      props,
      handleUpdateStructure,
    };
  },
});
</script>

<style lang="less" scoped>
.structure {
  font-size: 17px;
  width: 260px;
  padding: 5px 10px;
  cursor: pointer;
  .icon {
    width: 30px;
    height: 30px;
    border: 1px solid #ccc;
    margin-right: 10px;
    border-radius: 7px;
  }
}
</style>
